module.exports = __webpack_public_path__ + "images/c83c323e3de076cc82eca400bfa377f1-copy-to-clipboard.png";